require('backbone.validation');

Backbone.Validation.configure({
    forceUpdate: true
});

_.extend(Backbone.Validation.callbacks, {
    valid: function (view, attr) {
        let legalAttr = attr.replace('.', '_'),
            $el = view.$('[name=' + legalAttr + ']'),
            $group = $el.closest('.form-group');
        $group.removeClass('has-error');
        $group.find('.help-block').html('').addClass('hidden');
    },
    invalid: function (view, attr, error) {
        let legalAttr = attr.replace('.', '_'),
            $el = view.$('[name=' + legalAttr + ']'),
            $group = $el.closest('.form-group');

        $group.addClass('has-error');
        $group.find('.help-block').html(error).removeClass('hidden');
    }
});
